export const payload = {
  receiveMutation: 'RECEIVE_MARKUP',
  receivingMutation: 'RECEIVING_MARKUP',
  receiveMetadataMutation: 'RECEIVE_MARKUP_METADATA',
  savingMutation: 'SAVING_MARKUP',
  updatingMutation: 'UPDATING_MARKUP',
  deleteMutation: 'DELETE_MARKUP',
  deletingMutation: 'DELETING_MARKUP',
  incrementMutation: 'INCREMENT_MARKUP_COUNT',
  resetMetaMutation: 'RESET_MARKUP_META',
  clearMutation: 'CLEAR_MARKUP_STATE',
  moduleName: 'markup',
  endpoint: 'markups',
  defaultModelGetter: 'getDefaultMarkup',
  searchableFields: ['code', 'name', 'description']
}
